import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Persone',
    financial_metrics: 'Metriche finanziarie',
    onboarding_and_quality: 'Onboarding e Qualità',
    subscriptions: 'Abbonamenti attivi',
    payments: 'Pagamenti',
    last_invoices: 'Ultime fatture',
  },
  fields: {
    google_profile: 'Profilo Google',
    owner_name: 'Nome titolare',
    owner_phone_number: 'Tel. titolare',
    company_phone_number: 'Tel. ristorante',
    address: 'Indirizzo',
    onboarding_manager: 'Responsabile onboarding',
    sales_manager: 'Responsabile vendite',
    last_30_days_sales: 'Fatturato ultimi 30 giorni',
    lifetime_sales: 'Fatturato totale',
    monthly_sales_other_platforms: 'Vendite App Delivery',
    last_payout: 'Ultimo pagamento',
    potential_tier: 'Punteggio Potenziale',
    current_tier: 'IST Score',
    signed_at: 'Data chiusura',
    live_from: 'Data Go Live',
    onboarding_quality_score: 'Punteggio Qualità Go Live',
    is_google_business_available: 'Google Business disponibile',
    is_smart_pricing_configured: 'Prezzi inferiori a Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Volantino promo inviato',
    is_menu_fully_configured: 'Tutti gli articoli del menu disponibili',
    has_offers_on_competitor_platforms:
      "Il ristorante ha offerte attive su Wolt, Uber, Lieferando (esclusa l'offerta consegna gratuita)?",
    is_instagram_story_shared: 'Story Instagram condivisa con il titolare',
    is_order_system_connected_to_website:
      'Sito Foodamigos collegato O pulsante ordine online aggiunto al sito del ristorante',
    delivery_mode: 'Corrieri',
    has_storefront: 'Sito {{provider}}',
    screening_date: 'Data screening',
  },
  setup_fee: {
    title: 'Commissione di implementazione',
    status: {
      [InvoiceStatus.Paid]: 'Pagato',
      [InvoiceStatus.Pending]: 'In attesa',
      [InvoiceStatus.Processing]: 'In elaborazione',
      [InvoiceStatus.Refunded]: 'Rimborsato',
      [InvoiceStatus.PartiallyRefunded]: 'Parzialmente rimborsato',
      [InvoiceStatus.Failed]: 'Fallito',
    },
  },
  labels: {
    yes: 'Sì',
    no: 'No',
    month: 'Mese',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Attivo',
    [CompanyOperationalStatus.Paused]: 'In pausa',
    [CompanyOperationalStatus.Suspended]: 'Disdetto',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Mensile',
    [SubscriptionTerm.Annual]: 'Annuale',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Autisti propri',
    [DeliveryMode.External]: 'Autisti {{provider}}',
  },
  buttons: {
    view_details: 'Visualizza dettagli',
    open: 'Apri',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati fallito',
  },
};
